/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "stippel",
  "i18n.actionBar.removeImage": "Verwijderen",
  "i18n.actionBar.swapImage": "Vervangen",
  "i18n.additionalInfoItemLayers.smartSorted.new": "NIEUW!",
  "i18n.additionalProducts.addToCart": "Aan de bestelling toevoegen",
  "i18n.additionalProducts.frame.description": "Hoogwaardig aluminium kader: mat zilver, premium echt glas, geen lijm nodig",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Tip:",
  "i18n.additionalProducts.frame.subtitle": "De gelegde puzzel is een prachtig aandenken – en komt dankzij onze <b>kader</b> helemaal tot zijn recht.",
  "i18n.additionalProducts.frame2023.description": "Hoogwaardige houtvezelkader – eenvoudig te monteren, zonder glas, incl. puzzellijm",
  "i18n.additionalProducts.framePlastic.description": "Hoogwaardig aluminium kader: mat zilver, ontspiegeld synthetisch glas, geen lijm nodig",
  "i18n.additionalProducts.glue.description": "Voor maximaal twee puzzels van 1000 stukjes, incl. applicatiesponsje",
  "i18n.additionalProducts.glue.hook": "Zo wordt je puzzel een schilderij.\nLijmt en beschermt blijvend.",
  "i18n.additionalProducts.roll.description": "Voor puzzels van 48 t/m 2000 stukjes",
  "i18n.additionalProducts.roll.hook": "Geen vrije tafel? Geen probleem.\nPuzzel oprollen, opbergen en later verder puzzelen.",
  "i18n.adventCalendarOverlay.activate": "24 deurtjes- preview laten zien",
  "i18n.adventCalendarOverlay.deactivate": "24 deurtjes- preview uitzetten",
  "i18n.adventCalendarOverlay.notice": "(de cijfers en lijnen worden niet gedrukt)",
  "i18n.button.addToCart": "In de winkelwagen",
  "i18n.button.apply": "Toepassen",
  "i18n.button.back": "Terug",
  "i18n.button.cancel": "Annuleren",
  "i18n.button.cancelAndFix": "Nu veranderen",
  "i18n.button.chooseSmartSorted": "SMART SORTED kiezen",
  "i18n.button.close": "Sluiten",
  "i18n.button.continue": "Verder",
  "i18n.button.createNewTextPlaceholders": "Tekst op de puzzel zetten",
  "i18n.button.ignore": "Ignoreren",
  "i18n.button.ignoreAndContinue": "Toch verder gaan",
  "i18n.button.mobile.createNewTextPlaceholders": "Tekst plaatsen",
  "i18n.button.noChanges": "Zonder SMART SORTED",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Foto's",
  "i18n.button.retry": "Opnieuw proberen",
  "i18n.button.uploadPhotos": "Upload foto('s)",
  "i18n.button.withSmartSorted": "Met SMART SORTED",
  "i18n.button.withoutSmartSorted": "Zonder SMART SORTED",
  "i18n.control.colorChooser.color": "Kleur",
  "i18n.control.fontChooser.placeholderText": "Lettertype",
  "i18n.control.imageQuality.checkImages": "Controleer de foto resolutie",
  "i18n.control.imageQuality.imageSuitability": "Foto resolutie:",
  "i18n.control.imageQuality.indicatorAltText": "Foto resolutie",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Kies een Layout",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Voor een betere leesbaarheid, a.u.b. de tekst / lengte van de regel inkorten.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Het gekozen lettertype is te groot voor deze tekst.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Het maximale letterformaat voor deze tekst is bereikt.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Het minimale letterformaat voor deze tekst is bereikt.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Voor een betere leesbaarheid, a.u.b. de tekst / lengte van de regel inkorten.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Voeg a.u.b. een regeleinde in",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Controleer a.u.b. je tekst. Dit lettertype ondersteunt niet alle tekens.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Het maximale aantal letters is bereikt",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Voor een betere leesbaarheid, a.u.b. de tekst / lengte van de regel inkorten.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "A.u.b. het tekstveld groter maken",
  "i18n.dialog.deletePlaceholder.message": "Deze stap kan niet ongedaan worden gemaakt",
  "i18n.dialog.deletePlaceholder.title": "Plaatshouder echt wissen?",
  "i18n.dialog.error.title": [
    "Er is een fout opgetreden",
    "Er zijn fouten opgetreden"
  ],
  "i18n.dialog.insufficientImageQuality.message": "De resolutie van deze foto is te laag om de foto scherp te kunnen drukken!",
  "i18n.dialog.smartSorted.message": "Met SMART SORTED maak je jouw fotopuzzel met 1000 stukjes op een innovatieve en ontspannen manier af, zelfs zonder een voorbeeldfoto.",
  "i18n.dialog.smartSorted.title": "Puzzel succes belevenis gegarandeerd",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klik op \"{{text}}\", om de titel op de doos te veranderen.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "De titel op de doos is niet veranderd",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Verder gaan zonder titel op de doos",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Klik a.u.b. op de plaatshouder om de foto in te voegen",
    "Klik a.u.b. op de plaatshouders om de foto's in te voegen"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Een plaatshouder is nog leeg.",
    "Sommige plaatshouders zijn nog leeg"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Een plaatshouder is nog niet veranderd.",
    "Sommige plaatshouders zijn nog niet veranderd."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Een plaatshouder is nog leeg",
    "Sommige plaatshouders zijn nog leeg"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Een plaatshouder is nog onveranderd",
    "Sommige plaatshouders zijn nog onveranderd"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Klik a.u.b. op de plaatshouder om de tekst te veranderen",
    "Klik a.u.b. op de plaatshouders om de teksten te veranderen"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Een tekst plaatshouder is nog niet veranderd",
    "Sommige tekst plaatshouders zijn nog niet veranderd"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Onveranderde plaatshouders",
  "i18n.error.additionalInfoItemsError.message": "Een informatie layer kon niet worden geladen",
  "i18n.error.additionalInfoItemsError.title": "Laadfout",
  "i18n.error.deprecatedBrowserError.message": "De browser die u gebruikt, wordt niet langer ondersteund. Werk deze alsjeblieft bij naar een nieuwere versie.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Er is tijdens het ontwerpen een te lange pauze gemaakt, helaas kan het nu niet meer worden voortgezet. Wilt u het ontwerpproces a.u.b. opnieuw beginnen?",
  "i18n.error.designerExpiredError.title": "Ontwerpproces afgelopen",
  "i18n.error.fontLoadingError.message": "Een lettertype kon niet worden geladen",
  "i18n.error.fontLoadingError.title": "Laadfout",
  "i18n.error.imageLoadingError.message": "Eén foto kon niet worden geupload\nHij is uit de galerij en het ontwerpgedeelte verwijderd.",
  "i18n.error.imageLoadingError.title": "Download fout",
  "i18n.error.imageProvisionError.message": "Eén of meerdere foto's konden niet worden verwerkt. Het mediatype wordt waarschijnlijk niet ondersteund.",
  "i18n.error.imageProvisionError.title": "Eén foto kon niet worden verwerkt",
  "i18n.error.imageSelectionError.message": "File \"{{reference1}}\" kon niet worden verwerkt.",
  "i18n.error.imageSelectionError.title": "Fout tijdens foto upload",
  "i18n.error.imageSizeLimitExceededError.message": "De foto die je hebt geüpload is te omvangrijk.\nVerklein je foto tot minder dan 180 megapixels en upload hem opnieuw.",
  "i18n.error.imageSizeLimitExceededError.title": "Fout tijdens foto upload",
  "i18n.error.imageUploadError.message": "Er is een probleem met de internetverbinding opgetreden.\nProbeer het a.u.b. later nog een keer.",
  "i18n.error.imageUploadError.title": "Fout tijdens foto upload",
  "i18n.error.inlineSVGLoadingError.message": "Het tolerantie frame \"{{reference1}}\" kon niet worden geladen.",
  "i18n.error.inlineSVGLoadingError.title": "Download fout",
  "i18n.error.invalidCharConfigError.message": "Dit lettertype kan niet worden toegepast",
  "i18n.error.invalidCharConfigError.title": "Lettertype niet passend",
  "i18n.error.malformedProductError.message": "Eén of meer producten konden niet naar onze server worden overgebracht. Het is mogelijk dat het product niet meer beschikbaar is of dat de voorbereiding van het product te lang heeft geduurd. Je dient nu opnieuw te beginnen. Onze excuses voor het ongemak.",
  "i18n.error.malformedProductError.title": "Upload fout",
  "i18n.error.notInStockError.message": "Het door jou gekozen product is actueel niet beschikbaar.\nDoor op ons logo linksboven te klikken, kom je op de startpagina, waar een ander product kan worden gekozen.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Je internetverbinding lijkt te zijn onderbroken. Je kunt het ontwerpen van jouw product voortzetten, zodra je internetverbinding is hersteld.",
  "i18n.error.templateLoadingError.message": "Template \"{{ error.reference[0] }}\" kon niet worden geladen.\nProbeer het a.u.b. later nog een keer.",
  "i18n.error.templateLoadingError.title": "Download fout",
  "i18n.error.transformationError.message": "De verandering kon niet worden toegepast",
  "i18n.error.transformationError.title": "Transormeringsfout",
  "i18n.error.traudlLoadingError.message": "Probeer het a.u.b. nog eens of gebruik een andere foto.",
  "i18n.error.traudlLoadingError.title": "Er kon geen AI-filter worden toegepast.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" heeft een niet ondersteund mediatype.",
  "i18n.error.unsupportedMediaTypeError.title": "Fout tijdens foto upload",
  "i18n.error.uploadProductError.message": "Eén of meerdere producten konden niet naar de server worden gestuurd.\nProbeer het a.u.b. later nog een keer.",
  "i18n.error.uploadProductError.title": "Transfer fout",
  "i18n.error.zoomModeError.message": "De tekst kon niet worden overgenomen. Vul a.u.b. een nieuwe tekst in",
  "i18n.error.zoomModeError.title": "Tekst niet geadopteerd",
  "i18n.gallery.uploadPhotos.info": "Klik a.u.b. op de \"Upload foto's\" button",
  "i18n.gallery.uploadProgress": [
    "Foto upload ...",
    "Foto's geupload: {{current}} van {{total}}"
  ],
  "i18n.price.price": "Prijs",
  "i18n.price.reduction": "Je spaart",
  "i18n.price.total": "Prijs totaal",
  "i18n.priceDisplay.times": [
    "{{value}} stuk à {{pricePerUnit}}",
    "{{value}} stuks à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Benodigdheden (optioneel)",
  "i18n.progressOverlay.message.lines.one": "Bedankt voor je ontwerp.",
  "i18n.progressOverlay.message.lines.two": "We bereiden de volgende stap voor je voor...",
  "i18n.template.insertText": "Hier een tekst invullen",
  "i18n.toolbox.gallery.title": "Kies foto's",
  "i18n.toolbox.image.title": "Bewerk foto",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 foto",
    "{{value}} foto's"
  ],
  "i18n.toolbox.layout.title": "Kies een layout",
  "i18n.toolbox.layout.triggerText": "Layout",
  "i18n.toolbox.preview.title": "3D Preview",
  "i18n.toolbox.productChooser.title": "Verander product",
  "i18n.toolbox.productChooser.triggerText": "Product",
  "i18n.toolbox.text.title": "Tekst bewerken"
};


export class LocaleNlBE {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
